import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import {
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { fcpiDeliveryModeOptions } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'fcpi-setting',
    templateUrl: './fcpi-setting.component.html',
    styleUrls: ['./fcpi-setting.component.scss'],
    standalone: false
})
export class FcpiSettingComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  pledge: PledgeRead;
  parameters: Parameters;
  fcpiDeliveryModeOptions = fcpiDeliveryModeOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.pledge = this.subscriptionFacade.getPledge();
    this.parameters = this.pledge.parameters;

    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
